import React from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import GuardedRoute from './GuardedRoute';
import UnGuardedRoute from './UnGuardedRoute';
import Analytics from '../../components/analytics/Analytics';
import CaseCreated from '../../components/caseCreated/CaseCreated';
import EduTerms from '../../components/eduTerms/EduTerms';
import Privacy from '../../components/privacy/Privacy';
import Terms from '../../components/terms/Terms';
import CanRequestVideo from '../../guards/CanRequestVideo';
import AuthSuccess from '../authSuccess/AuthSuccess';
import CaseDetails from '../caseDetails/CaseDetails';
import Cases from '../cases/Cases';
import ConfirmDowngrade from '../confirmDowngrade/ConfirmDowngrade';
import ConfirmToken from '../confirmToken/ConfirmToken';
import CreateCase from '../createCase/CreateCase';
import CreatePassword from '../createPassword/CreatePassword';
import CreateWorkspace from '../createWorkspace/CreateWorkspace';
import Creators from '../creator/Creators';
import CreatorDashboard from '../creatorDashboard/CreatorDashboard';
import Discounts from '../discounts/Discounts';
import Downgrade from '../downgrade/Downgrade';
import Download from '../download/Download';
import EditWorkspace from '../editWorkspace/EditWorkspace';
import ForgotPassword from '../forgotPassword/ForgotPassword';
import Inactivity from '../inactivity/Inactivity';
import Login from '../login/Login';
import Logs from '../logs/Logs';
import myAccount from '../myAccount/myAccount';
import ObservationDetails from '../observation/ObservationDetails';
import ObservationReports from '../observation/ObservationReports';
import TechnologistEvaluationView from '../observation/TechnologistEvaluationView';
import OrderList from '../orderList/OrderList';
import PasswordResetSuccess from '../passwordResetSuccess/PasswordResetSuccess';
import PatientAccount from '../patientAccount/PatientAccount';
import PatientDashboard from '../patientDashboard/PatientDashboard';
import PatientList from '../patientList/PatientList';
import PatientReport from '../patientReport/PatientReport';
import PackagePlans from '../payment/PackagePlans';
import PaymentRedirectResult from '../payment/PaymentRedirectResult';
import StoragePlans from '../payment/StoragePlans';
import PersonalizedVideoReport from '../personalizedVideoReport/PersonalizedVideoReport';
import QuizView from '../quiz/QuizView';
import QuizzesView from '../quiz/QuizzesView';
import QuizDetailsView from '../quiz-details/QuizDetailsView';
import Register from '../register/Register';
import StandaloneReportViewer from '../report-viewer/StandaloneReportViewer';
import ReportEditorView from '../ReportEditor/ReportEditorView';
import Resources from '../resources/Resources';
import SelfHelpMaterials from '../selfHelpMaterials/SelfHelpMaterials';
import TechnologistSummaryView from '../technologist/TechnologistSummaryView';
import TechQASettings from '../techQASettings/TechQASettings';
import TemplateList from '../template/TemplateList';
import TemplateDetails from '../template-details/TemplateDetails';
import UpgradePlan from '../upgradePlan/UpgradePlan';
import UsersView from '../users/UsersView';
import VideoReport from '../videoReport/VideoReport';
import Viewer from '../viewer/Viewer';
import WorklistView from '../worklist/WorklistView';
import Workspaces from '../workspaces/Workspaces';

export default () => {
  const { host } = window.location;
  const subdomain = host.split('.')[0];
  const defaultSubdomain = process.env.REACT_APP_DOMAIN_POSTFIX?.split('.')[0];
  const isClinic = subdomain !== defaultSubdomain;

  return (
    <Switch>
      <GuardedRoute path="/" exact />
      <GuardedRoute path="/analytics" exact component={Analytics} />
      <GuardedRoute path="/my-account" exact component={myAccount} />
      <GuardedRoute path="/new-workspace" exact component={CreateWorkspace} />
      <GuardedRoute path="/creators" exact component={Creators} />
      <GuardedRoute path="/workspaces" exact component={Workspaces} />
      <GuardedRoute path="/cases" exact component={Cases} />
      <GuardedRoute path="/creator-dashboard" exact component={CreatorDashboard} />
      <GuardedRoute path="/case-details" exact component={CaseDetails} />
      <GuardedRoute path="/add-case" exact component={CreateCase} />
      <GuardedRoute path="/payment-subscription-success" exact component={() => <PaymentRedirectResult purpose="payment-subscription-success" />} />
      <GuardedRoute path="/payment-package-success" exact component={() => <PaymentRedirectResult purpose="payment-package-success" />} />
      <GuardedRoute path="/payment-fail" exact component={() => <PaymentRedirectResult purpose="payment-fail" />} />
      <GuardedRoute path="/payment-successful" exact component={() => <PaymentRedirectResult purpose="payment-successful" />} />
      <GuardedRoute path="/case-created" exact component={CaseCreated} />
      <GuardedRoute path="/edit-workspace" exact component={EditWorkspace} />
      <GuardedRoute path="/logs" exact component={Logs} />
      <GuardedRoute path="/users" exact component={UsersView} />
      <GuardedRoute path="/worklist" exact component={WorklistView} />
      <GuardedRoute path="/reports" exact component={ObservationReports} />
      <GuardedRoute path="/observation/:id" exact component={ObservationDetails} />
      <GuardedRoute path="/technologist-evaluation/:id" exact component={TechnologistEvaluationView} />
      <GuardedRoute path="/technologist-summary/:technologistId" exact component={TechnologistSummaryView} />
      <GuardedRoute path="/patients" exact component={PatientList} />
      <GuardedRoute path="/personalized-video" exact component={PersonalizedVideoReport} guard={CanRequestVideo} />
      <GuardedRoute path="/patient-report" exact component={PatientReport} />
      <GuardedRoute path="/package-plans" exact component={PackagePlans} />
      <GuardedRoute path="/storage-plans" exact component={StoragePlans} />
      <GuardedRoute path="/patient-dashboard" exact component={PatientDashboard} />
      <GuardedRoute path="/patient-account" exact component={PatientAccount} />
      <GuardedRoute path="/upgrade-plan" exact component={UpgradePlan} />
      <GuardedRoute path="/downgrade" exact component={Downgrade} />
      <GuardedRoute path="/confirm-downgrade" exact component={ConfirmDowngrade} />
      <GuardedRoute path="/resources" exact component={Resources} />
      <GuardedRoute path="/edu-terms" exact component={EduTerms} />
      <GuardedRoute path="/orders" exact component={OrderList} />
      <GuardedRoute path="/self-help-materials" exact component={SelfHelpMaterials} />
      <GuardedRoute path="/discounts" exact component={Discounts} />
      <GuardedRoute path="/collections" exact component={TemplateList} />
      <GuardedRoute path="/collections/:id" exact component={TemplateDetails} />
      <GuardedRoute path="/collection-new" exact component={TemplateDetails} />
      <GuardedRoute path="/quizzes" exact component={QuizzesView} />
      <GuardedRoute path="/quizzes/:id" exact component={QuizDetailsView} />
      <GuardedRoute path="/quiz/:id" exact component={QuizView} />
      <GuardedRoute path="/tech-qa-settings" exact component={TechQASettings} />
      <UnGuardedRoute path="/confirm-token" exact component={ConfirmToken} allowAuth />
      <UnGuardedRoute path="/terms" exact component={Terms} />
      <UnGuardedRoute path="/privacy" exact component={Privacy} />
      <UnGuardedRoute path="/inactivity" exact component={Inactivity} />
      <UnGuardedRoute path="/login" exact component={Login} />
      <UnGuardedRoute path="/forgot-password" exact component={ForgotPassword} />
      <UnGuardedRoute path="/password-reset-success" exact component={PasswordResetSuccess} />
      <UnGuardedRoute path="/register" exact component={Register} allow={!isClinic} />
      <UnGuardedRoute path="/auth-success" exact component={AuthSuccess} />
      <UnGuardedRoute path="/invite" exact component={() => <CreatePassword isInvite />} />
      <UnGuardedRoute path="/reset-password" exact component={CreatePassword} />
      <UnGuardedRoute path="/viewer" exact component={Viewer} allowAuth />
      <UnGuardedRoute path="/download/:resourceId" component={Download} allowAuth />
      <UnGuardedRoute path="/report-viewer" exact component={StandaloneReportViewer} allowAuth />
      <UnGuardedRoute path="/case-report/:caseId" exact component={ReportEditorView} allowAuth />
      <UnGuardedRoute path="/video-report/:resourceId" exact component={VideoReport} allowAuth />
      <UnGuardedRoute path="/public-template-new" exact component={TemplateDetails} allowAuth />

      <Route path="*" exact component={() => <Redirect to="/" />} />
    </Switch>
  );
};
